/* eslint-disable max-depth */
import { loginEndpoint } from './endpoints.js';
import showSnackBar from './snackbar';
import logger from './util-logger';

export default {
    init: () => {
        if ( document.querySelector('form') ) {
            const signin = document.querySelector('#signinForm');
            const chosenForm = document.querySelector('form.add-new-campaign:not([hidden])');
            const mediaForm = document.querySelector('#addNewCampaignFormMedia:not([hidden])');
            const searchForm = document.querySelector('#addNewCampaignFormSearch:not([hidden])');
            const emailForm = document.querySelector('#addNewCampaignFormEmail:not([hidden])');
            const validator = require('@klickinc/util-validator');

            const errors = (els, err) => {
                return [...els].reduce((e, f) => {
                    const errorDiv = document.getElementById(f.name + '-error');
                    return errorDiv && (err[f.name] ? errorDiv.classList.add('active') : errorDiv.classList.remove('active')) || e;
                }, false);
            };

            const validateField = rules => ({ target: e }) => errors([e], validator(rules, {
                __fields: [e.name],
                [e.name]: e.type === 'select-multiple' ? e.value : e.value
            }));

            const userSession = (session) => {
                localStorage.setItem('userSession', JSON.stringify(session));
                const data = localStorage.getItem('userSession');
                const userData = JSON.parse(data);
                const user = userData.userSession;
                localStorage.setItem('data.userSession.username', user.username);
                localStorage.setItem('data.userSession.role',  user.role);
                localStorage.setItem('data.userSession.csrfToken', user.csrfToken);
                localStorage.setItem('data.userSession.attributes', JSON.stringify(user.attributes))
            };

            const success = () => {
                const timeTwo = 650;
                showSnackBar.showSignIn('You are now logged in!');
                setTimeout( () => {
                    window.location.href = '/campaigns';
                }, timeTwo);
            };

            const failure = () => {
                document.querySelector('.mdl-spinner').classList.remove('is-active');
                document.querySelector('.form-error.mdl-textfield__error').removeAttribute('hidden');
                document.querySelector('.form-error.mdl-textfield__error').style.visibility = 'visible';
                document.querySelector('.form-error.mdl-textfield__error').style.position = 'relative';
            };

            const clearLoginError = () => {
                document.querySelector('.form-error.mdl-textfield__error').setAttribute('hidden', '');
                document.querySelector('.form-error.mdl-textfield__error').style.visibility = 'hidden';
            };

            const validateForm = rules => {
                return e => {
                    let formData = [];
                    errors(e.preventDefault() || e.target.elements, validator(rules, JSON.stringify(
                        formData = [...new FormData(e.target)].reduce((data, [name, value]) => {
                            const formEl = e.target.elements[name];
                            data[name] = formEl.type === 'select' ? formEl.selectedOptions : value;
                            return data;
                        }, {})
                    )));
                    const err = validator(rules, formData);
                    if (Object.keys(err).length < 1) {
                        if (signin) {
                            document.querySelector('.mdl-spinner').classList.add('is-active');
                            fetch(loginEndpoint, {
                                method: 'POST',
                                credentials: 'include',
                                mode: 'cors',
                                body: JSON.stringify(formData),
                                headers: new Headers({ 
                                    'Content-Type': 'application/json'
                                })
                            })
                                .then((response) => { return response.json(); })
                                .then((json) => {
                                    if ( json.success == true) {
                                        clearLoginError();
                                        document.querySelector('.mdl-spinner').classList.remove('is-active');
                                        const sess = json.data;
                                        for (const key in sess) {
                                            const name = sess[key].username;
                                            const token = sess[key].csrfToken;
                                            const role = sess[key].role;
                                            const attr = sess[key].attributes;
                                            userSession(sess);
                                        }
                                        success();
                                   } else {
                                    failure();
                                   }
                                }).catch((error) => {
                                    failure();
                                    logger.crit(error);
                                });
                        }
                    }
                };
            };

            const validate = (form, rules) => {
                if (!form) { return; }
                const field = validateField(rules);
                const submit = validateForm(rules);
                form.addEventListener('input', field);
                signin ? signin.addEventListener('submit', submit) : '';
            };

            const ruleSet = require('./ruleSet.js');

            if (signin) {
                validate(signin, ruleSet.signinForm.rules);
            }
            if ( chosenForm) {
                const formArea = chosenForm.querySelector('.inputAndSelect:not([hidden])');
                if (mediaForm) {
                    validate(formArea, ruleSet.addNewCampaignFormMedia.rules);
                } else if (searchForm) {
                    validate(formArea, ruleSet.addNewCampaignFormSearch.rules);
                } else if (emailForm) {
                    validate(formArea, ruleSet.addNewCampaignFormEmail.rules);
                } else if (document.querySelector('form#addPlacements')) {
                    validate(document.querySelector('form#addPlacements'), ruleSet.addPlacements.rules);
                } else if (document.querySelector('form#addCreatives')) {
                    validate(document.querySelector('form#addCreatives'), ruleSet.addCreatives.rules);
                } else if (document.querySelector('form#addAdGroups')) {
                    validate(document.querySelector('form#addAdGroups'), ruleSet.addAdGroups.rules);
                } else if (document.querySelector('form#addEmailNames')) {
                    validate(document.querySelector('form#addEmailNames'), ruleSet.addEmailNames.rules);
                } else if (document.querySelector('form#addCampaign')) {
                    validate(document.querySelector('form#addCampaign'), ruleSet.addCampaign.rules);
                }
            }
        } //end of if
    } // end of init
};